import React from "react";
import { Colors } from "../../ColorConstants";

const PromoApplied = ({ cart,onRemove }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        background: Colors.white,
        paddingLeft: "8px",
        width: "350px",
        borderRadius: "8px",
        boxSizing: "content-box",
      }}
    >
      <div
        style={{
          display: "flex",

          alignItems: "center",
        }}
      >
        <img src={require("../../assets/icons/promo-icon.png")} />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginLeft: "12px",
          }}
        >
          <div
            style={{ fontSize: "14px" }}
          >{`${cart?.promo?.toUpperCase()} applied`}</div>
          <div
            style={{ fontSize: "12px" }}
          >{`-QAR ${cart?.discountAmount} (${cart?.discountPercentage}% off)`}</div>
        </div>
      </div>
      <div
        onClick={onRemove}
        style={{
          height: "30px",
          background: Colors.red,
          color: Colors.white,
          width: "64px",
          padding: "8px",
          paddingTop: "16px",
          borderTopRightRadius: "8px",
          borderBottomRightRadius: "8px",
        }}
      >
        Remove
      </div>
    </div>
  );
};

export default PromoApplied;
